import type { StoreGroup } from '~~/models/Tariff/StoreGroup';
import type { Tariff } from "~~/models/Tariff/Tariff";

export const hasTenantTariffs = async (tenantId: string, storeId: string, params: {
    contractRenewal?: boolean,
    showInCarousel?: boolean,
    dsl?: boolean,
    cable?: boolean,
    fibre?: boolean,
    appleBonial?: boolean,
    refurbishedHighlights?: boolean,
    subTenant?: boolean,
    mobile?: boolean,
    young?: boolean,
    contentPageOnly?: boolean
}) => {
    const data = await $fetch<{ items: Tariff[] }>(
        `/api/nea/tariff-service/tenants/${tenantId}/tariffs/store/${storeId}`,
        {
            query: {
                ...params,
                page: 0,
                pageSize: 1,
                validOnly: true,
            }
        }
    );

    return (data?.items?.length ?? 0) > 0;
}

export const checkStoreHasPage = async (tenantId: string) => {    
    if (!tenantId) return null;
    const group = await $fetch<{ items: StoreGroup[] | null }>(
        `/api/nea/tariff-service/tenants/${tenantId}/storeGroup/store/${useCurrentStore()?.value?.id}`
    );
    if ((group?.items?.length ?? 0) < 1) {
        throw createError({
            statusCode: 404,
            statusMessage: 'Not Found',
            fatal: true
        });
    }
}